import { render, staticRenderFns } from "./SubEmpresaBlocoDadosContratoOriginacao.vue?vue&type=template&id=01b20c20&scoped=true&lang=pug"
import script from "./SubEmpresaBlocoDadosContratoOriginacao.vue?vue&type=script&lang=js"
export * from "./SubEmpresaBlocoDadosContratoOriginacao.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaBlocoDadosContratoOriginacao.vue?vue&type=style&index=0&id=01b20c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b20c20",
  null
  
)

export default component.exports